import { NgModule } from '@angular/core';
import { EventDispatcherComponent } from './event-dispatcher.component';
import { CommonModule } from '@angular/common';


@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        EventDispatcherComponent
    ],
    declarations: [
        EventDispatcherComponent
    ],
    providers: [
    ],
})
export class EventDispatcherModule { }
